import src from "IMAGE";
export default { src, width: 30, height: 998, blurWidth: 1, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAAICAYAAAA4GpVBAAAAJklEQVR42mOwDs0vYRC0yyln4LXOKGHgtckqgxIgrqA9UMIGqAQAwRQJ5zweLRsAAAAASUVORK5CYII="};
